<template>
  <l-layout :layout="['xs12']">
    <v-layout align-center class="pt-4" column style="height: 200px" v-if="loading">
      <v-progress-circular
        :color="'accent'"
        :value="100"
        size="50"
        indeterminate
      ></v-progress-circular>
      <!--<v-btn @click="goTo()">跳转</v-btn>-->
    </v-layout>
    <v-card v-for="(r,i) in rules" :key="i" class="ma-3" v-if="!loading">
      <v-layout column class="pa-3">
        <v-flex xs12 class="mb-2">
          规则基本信息
        </v-flex>
        <v-flex xs12 class="mb-1">
          <span class="caption grey--text pr-2">开始时间</span>
          <span class="mx-1">{{ r.startDatetime }}</span>
        </v-flex>
        <v-flex xs12 class="mb-1">
          <span class="caption grey--text pr-2">结束时间</span>
          <span class="mx-1">{{ r.endDatetime }}</span>
        </v-flex>
        <v-flex xs12 class="mb-3">
          <span class="caption grey--text pr-2">规则类型</span>
          <span class="mx-1">{{r.ruleType === 'sectional' ? '时段型':'周期型'}}</span>
          <span class="mx-2" v-if="r.ruleType === 'periodic'"></span>
          <span v-if="r.ruleType === 'periodic'">{{r.period === 'day'? '按天循环':'按周循环'}}</span>
        </v-flex>
        <template v-if="r.ruleType==='sectional'">
          <v-flex xs12 class="mb-2">
            通行卡口信息
          </v-flex>
          <v-layout column v-for="park in r.gateways" :key="park.id">
            <v-flex xs12 class="mb-1">
              <span class="caption grey--text pr-2">停车场区</span>
              <span class="mx-1">{{ park.name }}</span>
            </v-flex>
            <v-flex xs12 class="mb-2">
              <span class="caption grey--text pr-2">卡口列表</span>
              <span class="primary--text mx-1" @click="park.showControllers = !park.showControllers" v-if="!park.showControllers">查看允许通行卡口</span>
              <span class="primary--text mx-1" @click="park.showControllers = !park.showControllers" v-if="park.showControllers">隐藏允许通行卡口</span>
            </v-flex>
            <v-layout column v-if="park.showControllers" class="pl-5">
              <v-flex v-for="c in park.controllers" :key="c.id" class="pl-2">
                <p>{{c.name}}</p>
              </v-flex>
            </v-layout>
          </v-layout>
        </template>
        <template v-else>
          <v-layout v-for="(slice, index) in r.slices" column>
            <v-flex xs12 class="mb-2">
              时间片 {{index+1}}
            </v-flex>
            <v-flex xs12 class="mb-1">
              <span class="caption grey--text pr-2">开始时间</span>
              <span
                class="mx-1"
                v-if="r.period === 'week'"
              >{{ $L.time.showWeekday(slice.startWeekday, 'short') }}</span>
              <span>{{ slice.startTime }}</span>
            </v-flex>
            <v-flex xs12 class="mb-1">
              <span class="caption grey--text pr-2">结束时间</span>
              <span
                class="mx-1"
                v-if="r.period === 'week'"
              >{{ $L.time.showWeekday(slice.endWeekday, 'short') }}</span>
              <span>{{ slice.endTime }}</span>
            </v-flex>
            <v-layout column v-for="park in slice.gateways" :key="park.id">
              <v-flex xs12 class="mb-1">
                <span class="caption grey--text pr-2">停车场区</span>
                <span class="mx-1">{{ park.name }}</span>
              </v-flex>
              <v-flex xs12 class="mb-2">
                <span class="caption grey--text pr-2">卡口列表</span>
                <span class="primary--text mx-1" @click="park.showControllers = !park.showControllers" v-if="!park.showControllers">查看允许通行卡口</span>
                <span class="primary--text mx-1" @click="park.showControllers = !park.showControllers" v-if="park.showControllers">隐藏允许通行卡口</span>
              </v-flex>
              <v-layout column v-if="park.showControllers" class="pl-5">
                <v-flex v-for="c in park.controllers" :key="c.id" class="pl-2">
                  <p>{{c.name}}</p>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-layout>
        </template>
      </v-layout>
    </v-card >
    <v-card v-for="(r,i) in mobileRules" :key="i" class="ma-3" v-if="!loading">
      <v-layout column class="pa-3">
        <v-flex xs12 class="mb-2">
          规则基本信息
        </v-flex>
        <v-flex xs12 class="mb-1">
          <span class="caption grey--text pr-2">开始时间</span>
          <span class="mx-1">{{ r.startDatetime }}</span>
        </v-flex>
        <v-flex xs12 class="mb-1">
          <span class="caption grey--text pr-2">结束时间</span>
          <span class="mx-1">{{ r.endDatetime }}</span>
        </v-flex>
        <v-flex xs12 class="mb-3">
          <span class="caption grey--text pr-2">规则类型</span>
          <span class="mx-1">{{r.ruleType === 'sectional' ? '时段型':'周期型'}}</span>
          <span class="mx-2" v-if="r.ruleType === 'periodic'"></span>
          <span v-if="r.ruleType === 'periodic'">{{r.period === 'day'? '按天循环':'按周循环'}}</span>
        </v-flex>
        <template v-if="r.ruleType==='sectional'">
          <v-flex xs12 class="mb-2">
            通行卡口信息
          </v-flex>
          <v-layout column v-for="park in r.gateways" :key="park.id">
            <v-flex xs12 class="mb-1">
              <span class="caption grey--text pr-2">停车场区</span>
              <span class="mx-1">{{ park.name }}</span>
            </v-flex>
            <v-flex xs12 class="mb-2">
              <span class="caption grey--text pr-2">卡口列表</span>
              <span class="primary--text mx-1" @click="park.showControllers = !park.showControllers" v-if="!park.showControllers">查看允许通行卡口</span>
              <span class="primary--text mx-1" @click="park.showControllers = !park.showControllers" v-if="park.showControllers">隐藏允许通行卡口</span>
            </v-flex>
            <v-layout column v-if="park.showControllers" class="pl-5">
              <v-flex v-for="c in park.controllers" :key="c.id" class="pl-2">
                <p>{{c.name}}</p>
              </v-flex>
            </v-layout>
          </v-layout>
        </template>
        <template v-else>
          <v-layout v-for="(slice, index) in r.slices" column>
            <v-flex xs12 class="mb-2">
              时间片 {{index+1}}
            </v-flex>
            <v-flex xs12 class="mb-1">
              <span class="caption grey--text pr-2">开始时间</span>
              <span
                class="mx-1"
                v-if="r.period === 'week'"
              >{{ $L.time.showWeekday(slice.startWeekday, 'short') }}</span>
              <span>{{ slice.startTime }}</span>
            </v-flex>
            <v-flex xs12 class="mb-1">
              <span class="caption grey--text pr-2">结束时间</span>
              <span
                class="mx-1"
                v-if="r.period === 'week'"
              >{{ $L.time.showWeekday(slice.endWeekday, 'short') }}</span>
              <span>{{ slice.endTime }}</span>
            </v-flex>
            <v-layout column v-for="park in slice.gateways" :key="park.id">
              <v-flex xs12 class="mb-1">
                <span class="caption grey--text pr-2">停车场区</span>
                <span class="mx-1">{{ park.name }}</span>
              </v-flex>
              <v-flex xs12 class="mb-2">
                <span class="caption grey--text pr-2">卡口列表</span>
                <span class="primary--text mx-1" @click="park.showControllers = !park.showControllers" v-if="!park.showControllers">查看允许通行卡口</span>
                <span class="primary--text mx-1" @click="park.showControllers = !park.showControllers" v-if="park.showControllers">隐藏允许通行卡口</span>
              </v-flex>
              <v-layout column v-if="park.showControllers" class="pl-5">
                <v-flex v-for="c in park.controllers" :key="c.id" class="pl-2">
                  <p>{{c.name}}</p>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-layout>
        </template>
      </v-layout>
    </v-card>
    <v-layout justify-center class="mt-5" v-if="rules.length===0&&mobileRules.length===0&&!loading">
      <p>暂无规则</p>
    </v-layout>
  </l-layout>
</template>

<script>
    export default {
      name: "personPassRule",
      data(){
        return {
          rules:[],
          mobileRules:[],
          loading:false
        }
      },
      async created(){
        this.loading = true
        await this.getPassRules()
        await this.getMobilePhoneRule()
        this.loading = false
      },
      methods:{
        getLoginInfo(){
          return JSON.parse(sessionStorage.getItem('loginInfo'))
        },
        async getPassRules(){
          try{
            await this.$store.dispatch('login/initSystemInfo', false)
            let {items} = await this.$store.dispatch('wx/getPassRule',this.getLoginInfo().id)
            for(let i=0;i<items.length;i++){
              if(items[i].gateways.length!==0){
                for(let j=0;j<items[i].gateways.length;j++){
                  items[i].gateways[j].showControllers = false
                }
              }
              if(items[i].slices.length !== 0){
                for(let j=0;j<items[i].slices.length;j++){
                  if(items[i].slices[j].gateways.length!==0){
                    for(let k=0;k<items[i].slices[j].gateways.length;k++){
                      items[i].slices[j].gateways[k].showControllers = false
                    }
                  }
                }
              }
            }
            this.rules = items
            return
          }catch (e) {
            console.log(e)
          }
        },
        async getMobilePhoneRule(){
          try{
            await this.$store.dispatch('login/initSystemInfo', false)
            let p = await this.$store.dispatch('login/getSelfInfo')
            let {items} = await this.$store.dispatch('wx/getPassRule',p.phone)
            for(let i=0;i<items.length;i++){
              if(items[i].gateways.length!==0){
                for(let j=0;j<items[i].gateways.length;j++){
                  items[i].gateways[j].showControllers = false
                }
              }
              if(items[i].slices.length !== 0){
                for(let j=0;j<items[i].slices.length;j++){
                  if(items[i].slices[j].gateways.length!==0){
                    for(let k=0;k<items[i].slices[j].gateways.length;k++){
                      items[i].slices[j].gateways[k].showControllers = false
                    }
                  }
                }
              }
            }
            this.mobileRules = items
            return
          }catch (e) {
            console.log(e)
          }
        }
      }
    }
</script>

<style scoped>

</style>
